const WISHLIST_API = "https://nyan-tcg-inventory-manager-slack.vercel.app/api/wishlist";
let wishlistIds = new Set();
let customerId = window.__customerId;

async function loadWishlist() {
  if (!customerId) return;
  try {
    const res = await fetch(`${WISHLIST_API}?customer_id=${customerId}`);
    const data = await res.json();
    wishlistIds = new Set((data.products || []).map(p => p.numericId));
    updateAllButtons();
  } catch (e) {
    console.error("wishlist load error:", e);
  }
}

function updateAllButtons() {
  document.querySelectorAll("[data-wishlist-btn]").forEach(btn => {
    const pid = btn.dataset.productId;
    if (wishlistIds.has(String(pid))) {
      btn.classList.add("wishlist-active");
      btn.setAttribute("aria-label", "お気に入りから削除");
    } else {
      btn.classList.remove("wishlist-active");
      btn.setAttribute("aria-label", "お気に入りに追加");
    }
  });
}

async function toggleWishlist(productId) {
  if (!customerId) {
    window.location.href = window.__loginUrl || "https://shopify.com/79453389030/account";
    return;
  }

  const pid = String(productId);
  const isInWishlist = wishlistIds.has(pid);

  if (isInWishlist) {
    wishlistIds.delete(pid);
  } else {
    wishlistIds.add(pid);
  }
  updateAllButtons();

  try {
    const res = await fetch(WISHLIST_API, {
      method: isInWishlist ? "DELETE" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ customer_id: customerId, product_id: pid }),
    });
    const data = await res.json();
    if (data.error) throw new Error(data.error);
  } catch (e) {
    if (isInWishlist) {
      wishlistIds.add(pid);
    } else {
      wishlistIds.delete(pid);
    }
    updateAllButtons();
    console.error("wishlist toggle error:", e);
  }
}

// Attach onclick directly to each button (avoids product-card.js interception)
function attachWishlistHandlers() {
  document.querySelectorAll("[data-wishlist-btn]").forEach(btn => {
    if (btn._wishlistAttached) return;
    btn._wishlistAttached = true;
    btn.addEventListener("mousedown", function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleWishlist(this.dataset.productId);
    }, true);
    btn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  });
}

// Observe DOM changes to attach handlers to dynamically added buttons
const observer = new MutationObserver(attachWishlistHandlers);
observer.observe(document.body, { childList: true, subtree: true });

// Initial attach
attachWishlistHandlers();
loadWishlist();

window.__wishlistApi = { WISHLIST_API, loadWishlist, toggleWishlist, getIds: () => wishlistIds };
